import axios from "./axios";

export const fetchAllCoupons = async () => {
  const { data } = await axios.get("/get/coupons");
  return data;
};
